module.exports = __webpack_public_path__ + "static/unity_img_1-7e903fc68beb9dca183ebe1c9896673b.png";